import { createContext } from 'react';

import { Notifications } from '@Types/common/Notifications';

export const NotificationContext = createContext<Notifications>({
  saveSuccessNotification: () => null,
  submitSuccessNotification: () => null,
  editSuccessNotification: () => null,
  deleteSuccessNotification: () => null,
  cancelSuccessNotification: () => null,
  successNotification: () => null,
  errorNotification: () => null,
  taskApprovedNotification: () => null,
  taskRejectedNotification: () => null,
  taskErrorNotification: () => null,
  taskIsAlreadyApprovedRejected: () => null,
});
